import type { FC } from 'react';

import { ControlledSelect, addAllSelectOption } from '@components/Form';
import type { ControlledSelectProps } from '@components/Form';
import { useVrsTypeSelect } from '@hooks/useVrsTypeSelect';

import type { SearchFilterFormValues } from './ScanDevicesTableSearchFilter';

export type ControlledVrsTypeSelectProps = Omit<
  ControlledSelectProps<SearchFilterFormValues>,
  'options'
>;

export const SearchFilterControlledVrsTypeSelect: FC<ControlledVrsTypeSelectProps> = ({
  textFieldProps,
  ...props
}) => {
  const { options, isLoading } = useVrsTypeSelect(addAllSelectOption);

  if (isLoading) return null;

  return (
    <ControlledSelect
      {...props}
      options={options}
      textFieldProps={{ ...textFieldProps, size: 'small' }}
    />
  );
};
